export default "__VITE_ASSET__aIB8uK6B__"